import store from '@/Store'

const setupApp = store.state.SetupApp

const detalheExtrato = async (idReembolso, numeroGuiaReembolso) => {
  let payload = {
    idReembolso,
    numeroGuiaReembolso
  }

  const response = await setupApp.apiFuncionalidade.detalhe({
    payload: payload,
    loading: true,
    handlerErrorIgnore: [404]
  })
  return response.data
}

const acionaFuncionalidade = async (req) => {
  const data = {
    type: 'texto',
    message: `${req.data.textoWidget}`
  }
  return { status: true, data, message: 'sucesso' }
}

export {
  detalheExtrato,
  acionaFuncionalidade
}
